import type { TOC } from '@ember/component/template-only';
import { PrismCard } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { Illustration } from 'frontend-utils';
import MyAndMarketOtbIllustration from 'lumen/assets/images/upsell/my-and-market-otb.svg?raw';
import MyOtbIllustration from 'lumen/assets/images/upsell/my-otb.svg?raw';
import GeneralButtonsOtbSelfServiceButton from 'lumen/components/general/buttons/otb-self-service-button';
import GeneralEmptyStateDataValidation from 'lumen/components/general/empty-state-data-validation';
import hasFeature from 'lumen/helpers/has-feature';
import {
  OTB_SS_ENTRY_POINTS,
  OTB_SS_VIA_QP_VALUES,
} from 'lumen/utils/constants/otb-selfservice-constants';

interface HotelMarketInsightCardsEmptyStateOccupancyCardSignature {
  Args: {};
}

const HotelMarketInsightCardsEmptyStateOccupancyCard: TOC<HotelMarketInsightCardsEmptyStateOccupancyCardSignature> =
  <template>
    {{! @glint-nocheck: not typesafe yet }}
    <PrismCard class="detail-pane-card empty-state-occupancy-card">
      <:header as |Header|>
        <Header.title>
          {{t "general.occupancy"}}
        </Header.title>
      </:header>
      <:content>
        {{#if (hasFeature "otb.empty_placeholder")}}
          <div class="flex flex-row">
            {{#if (hasFeature "otb.market_benchmark_eligible")}}
              <Illustration
                @html={{MyAndMarketOtbIllustration}}
                class="empty-state-occupancy__mock-image mr-400"
              />
            {{else}}
              <Illustration
                @html={{MyOtbIllustration}}
                class="empty-state-occupancy__mock-image mr-400"
              />
            {{/if}}

            <div class="flex flex-col">
              <span class="empty-state-occupancy-card__title">{{t
                  "market_insight.otb_ss.empty_state.kpi.occupancy.title"
                }}</span>
              {{#if (hasFeature "otb.market_benchmark_eligible")}}
                <span>{{t "market_insight.otb_ss.empty_state.paragraph"}}</span>
              {{else}}
                <span>{{t
                    "market_insight.otb_ss.empty_state.my_otb_only.paragraph"
                  }}</span>
              {{/if}}
            </div>
          </div>

          <div class="empty-state-occupancy-card__otb-ss-button">
            <GeneralButtonsOtbSelfServiceButton
              @otbSelfServiceEntryPoint={{OTB_SS_ENTRY_POINTS.MI_OCCUPANCY_CARD}}
              @otbSelfServiceEntryProduct={{OTB_SS_VIA_QP_VALUES.MARKET_INSIGHT}}
            />
          </div>
        {{else}}
          <GeneralEmptyStateDataValidation />
        {{/if}}
      </:content>
    </PrismCard>
  </template>;

export default HotelMarketInsightCardsEmptyStateOccupancyCard;
